import { useMemo, useState } from 'react';
import { timestampIntegrators } from '../../timestampIntegrators';
import { REQUEST, RESPONSE, CREATED_TIMESTAMP } from '../../constants';

export const useTheTradeDeskIntegrator = (data, pods) => {
  const [requestNumber, setRequestNumber] = useState(null);
  const integratorPods = data?.demandPods?.length ? data?.demandPods : pods;

  const handleRequestChange = (requestNumber) => setRequestNumber(requestNumber);

  const { summary, requestParams, request, response, ttdPods, availableRequestNumbers } = useMemo(() => {
    const targetRequest = data?.[REQUEST]?.find((req) => req?.requestNumber === requestNumber);
    const targetResponse = data?.[RESPONSE]?.find((res) => res?.requestNumber === requestNumber);
    const { id, imp, app, device, geo } = targetRequest?.record?.rawData ?? {};

    return {
      summary: {
        timestamp: timestampIntegrators(targetResponse?.record?.[CREATED_TIMESTAMP]),
        endpoint: '',
        requestID: id,
        ...(imp &&
          imp?.reduce(
            (acc, item, idx) => ({
              ...acc,
              [`impressionID-${idx + 1}`]: item?.id,
              [`maxAds-${idx + 1}`]: item?.video?.maxseq,
              [`maxPodDuration-${idx + 1}`]: item?.video?.poddur,
              [`guar`]: item?.pmp?.deals?.[0].guar,
            }),
            {}
          )),
        appName: app?.name,
        entitlement: app?.content?.language,
        appPublisher: app?.publisher?.name,
        playbackType: app?.content?.livestream,
        deviceIPv6: device?.ipv6,
        deviceIPv4: device?.ip,
        deviceIFA: device?.ifa,
        deviceIFAType: device?.ext?.['ifa_type'],
        deviceUserAgent: device?.ua,
        doNotTrack: device?.dnt,
        limitedAdTracking: device?.lmt,
        geo: geo?.country,
      },
      requestParams: targetRequest?.record?.rawData ?? {},
      request: targetRequest?.record?.rawData ?? {},
      response: targetResponse?.record?.rawData ?? {},
      ttdPods: integratorPods ?? [],
      availableRequestNumbers: data?.[REQUEST]
        ? data?.[REQUEST]?.sort((a, b) => a.requestNumber - b.requestNumber)?.map(({ requestNumber }) => ({
            id: requestNumber,
          }))
        : [],
    };
  }, [data, integratorPods, requestNumber]);

  return {
    summary,
    requestParams,
    request,
    response,
    ttdPods,
    availableRequestNumbers,
    requestNumber,
    handleRequestChange,
  };
};
